import React, { useContext, useEffect } from 'react';
import { Box } from '@mui/material';
import { nanoid } from 'nanoid';
import AutocompleteWithSearch from 'components/forms/AutocompleteWithSearch';
import CandidateCard from 'components/CandidateCard';
import CreateProcessContext from 'shared/contexts/CreateProcessContext';
import { DICTIONARY } from 'shared/constants';

const panelStyle = {
  marginTop: '1rem',
  '& > .MuiPaper-root': {
    marginBottom: '1rem',
  },
};

const ExistingIndividual: React.FC = () => {
  const {
    setProcess, selectedNational,
  } = useContext(CreateProcessContext);

  const handleNameSelect = (event: any, value: any) => {
    setProcess((draft) => {
      draft.foreignNationalID = value?.id;
    });
  };

  useEffect(() => {
    // Reset form
    setProcess((draft) => {
      draft.companyID = null;
      draft.employmentData = {};
      draft.employeeData = {
        firstname: '',
        lastname: '',
        tempID: nanoid(),
      };
      draft.individualSponsored = null;
      draft.requestedProcess = null;
    });
  }, []);

  return (
    <Box sx={panelStyle}>
      {selectedNational ? (
        <CandidateCard />
      ) : (
        <AutocompleteWithSearch
          label={DICTIONARY.ExistingIndividual}
          onChange={handleNameSelect}
          type="ForeignNational"
        />
      )}
    </Box>
  );
};

export default ExistingIndividual;
